import socket from "./socket";

const URL = process.env.REACT_APP_API_URL;

const SESSION_MAX_AGE_MS = 8 * 60 * 60 * 1000; // 8 horas

export function isAuthenticated() {
  try {
    const raw = sessionStorage.getItem("user");
    if (!raw) return false;

    const u = JSON.parse(raw);
    if (!u.loginTime) return true; // compat viejo

    const now = Date.now();
    if (now - u.loginTime > SESSION_MAX_AGE_MS) {
      // sesión vencida en frontend → limpiamos
      sessionStorage.removeItem("user");
      sessionStorage.removeItem("empresa_id");
      return false;
    }

    return true;
  } catch {
    return false;
  }
}

export const getUser = () => {
  try {
    const empresaData = sessionStorage.getItem("user");
    return empresaData ? JSON.parse(empresaData) : null;
  } catch (error) {
    console.error("Error al obtener datos de empresa:", error);
    return null;
  }
};

// Obtener datos específicos de la empresa
export const getEmpresa = () => {
  return getUser(); // Ahora user contiene datos de empresa
};

export const getEmpresaId = () => {
  const empresa = getEmpresa();
  return empresa?.empresa_id || empresa?.id || null;
};

export const getEmpresaNombre = () => {
  const empresa = getEmpresa();
  return empresa?.nombre || null;
};

export function getUserRole() {
  const context = getUserContext(); 
  return context?.rol || null;
}

export function isVendedor() {
  return getUserRole() === 'Vendedor';
}

export function isAdmin() {
  return getUserRole() === 'Admin';
}

export async function logout(onLogoutComplete) {
  const user = getUserContext();

  try {
    if (user && socket.connected) {
      socket.emit("leave_user", {
        user_id: user.id,
        user_rol: user.rol,
        empresa_id: user.empresa_id,
      });
    }
    await fetch(`${URL}/api/empresa/logout/`, {
      method: "POST",
      credentials: "include"
    });
  } catch (error) {
    console.error("Error logout", error);
  } finally {
    // Borra TODO
    sessionStorage.removeItem('user');
    sessionStorage.removeItem('empresa_id');
    sessionStorage.removeItem('active_module'); 
    sessionStorage.removeItem('active_profile'); 
    
    socket.disconnect();

    if (onLogoutComplete) {
      onLogoutComplete();
    }
  }
}


export function setProfile(profileData) {
  // Guardamos quién es el usuario final (Vendedor X)
  sessionStorage.setItem("active_profile", JSON.stringify(profileData));
}

export function getActiveProfile() {
  try {
    return JSON.parse(sessionStorage.getItem("active_profile"));
  } catch {
    return null;
  }
}

// Combina Empresa + Perfil para saber quién está usando el sistema
export function getUserContext() {
  const empresa = getUser(); 
  const profile = getActiveProfile();

  if (!empresa) return null;

  if (profile) {
    const empresaId = profile.empresa_id ?? empresa.empresa_id ?? empresa.id;
    const context = {
      ...empresa,       
      id: profile.id,
      usuario: profile.nombre, 
      rol: profile.rol, 
      isProfileActive: true,
      empresa_id: empresaId,
    };
    if (profile.rol === "Vendedor") {
      context.vendedor_id = profile.vendedor_id ?? profile.id;
    }
    if (profile.rol === "Admin") {
      context.administrador_id = profile.administrador_id ?? profile.id;
    }
    return context;
  }
  
  // Si no hay perfil, es solo la empresa logueada
  return { ...empresa, isProfileActive: false };
}


export function removeProfile() {
  // 1. Borramos solo el perfil del usuario final
  sessionStorage.removeItem("active_profile");
  
  // 2. Si el socket está conectado con ese usuario, lo desconectamos
  // para que al volver a elegir perfil se reconecte con el nuevo ID
  if (socket.connected) {
    socket.disconnect();
  }
}
